import actions from './actions';
import mutations from './mutations';

const state = {
    activatedCEModules: {},
    activatedCEModuleIds: []
};

const getters = {
    items: state => state.activatedCEModuleIds.map(id => state.activatedCEModules[id]),
    getActivatedCEModule: state => id => state.activatedCEModules[id]
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/activatedCEModules/store.js